import { AxiosInstance, AxiosPromise } from 'axios';

import {
  AutoscalerAPIApiFactory,
  EvictorAPIApiFactory,
  NodeTemplatesAPIApiFactory,
  PoliciesAPIApiFactory,
} from '@cast/openapi';
import { PodMutationsAPIApiFactory } from '@cast/openapi-patching-engine';
import { ClusterWorkloads, AutoscalerRebalancingPlan } from '@cast/types';

import { AXIOS_CONFIGURATION } from '../constants';

export const AutoscalerApiAdapter = (client: AxiosInstance) => {
  const policiesApi = PoliciesAPIApiFactory(AXIOS_CONFIGURATION, '', client);
  const selectionTemplatesApi = NodeTemplatesAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );
  const autoscalerApi = AutoscalerAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  const evictorApi = EvictorAPIApiFactory(AXIOS_CONFIGURATION, '', client);

  const podMutationsApi = PodMutationsAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  // prettier-ignore
  return {
    getPolicies: policiesApi.policiesAPIGetClusterPolicies,
    upsertPolicies: policiesApi.policiesAPIUpsertClusterPolicies,
    getNodeConstraints: policiesApi.policiesAPIGetClusterNodeConstraints,
    getSelectionTemplates: selectionTemplatesApi.nodeTemplatesAPIListNodeTemplates,
    createSelectionTemplate: selectionTemplatesApi.nodeTemplatesAPICreateNodeTemplate,
    updateSelectionTemplate: selectionTemplatesApi.nodeTemplatesAPIUpdateNodeTemplate,
    deleteSelectionTemplate: selectionTemplatesApi.nodeTemplatesAPIDeleteNodeTemplate,
    generateNodeTemplates: selectionTemplatesApi.nodeTemplatesAPIGenerateNodeTemplates,
    getInstanceTypes: selectionTemplatesApi.nodeTemplatesAPIFilterInstanceTypes,
    getAgentInstallScript: autoscalerApi.autoscalerAPIGetAgentScript,
    getAutoscalerFeatures: autoscalerApi.autoscalerAPIGetClusterSettings,
    listRebalancingPlans: autoscalerApi.autoscalerAPIListRebalancingPlans,
    executeRebalancingPlan: (...args: Parameters<typeof autoscalerApi.autoscalerAPIExecuteRebalancingPlan>): AxiosPromise<AutoscalerRebalancingPlan> => autoscalerApi.autoscalerAPIExecuteRebalancingPlan(...args),
    getProblematicWorkloads: autoscalerApi.autoscalerAPIGetProblematicWorkloads,
    getRebalancedWorkloads: autoscalerApi.autoscalerAPIGetRebalancedWorkloads,
    getRebalancingPlan: (...args: Parameters<typeof autoscalerApi.autoscalerAPIGetRebalancingPlan>): AxiosPromise<AutoscalerRebalancingPlan> => autoscalerApi.autoscalerAPIGetRebalancingPlan(...args),
    getWorkloads: (...args: Parameters<typeof autoscalerApi.autoscalerAPIGetClusterWorkloads>): AxiosPromise<ClusterWorkloads> => autoscalerApi.autoscalerAPIGetClusterWorkloads(...args) as AxiosPromise<ClusterWorkloads>,
    generateRebalancingPlan: autoscalerApi.autoscalerAPIGenerateRebalancingPlan,
    getAdvancedEvictorConfig: evictorApi.evictorAPIGetAdvancedConfig,
    updateAdvancedEvictorConfig: evictorApi.evictorAPIUpsertAdvancedConfig,
    getKarpenterMigrationIntents: autoscalerApi.autoscalerAPIGetKarpenterDefinitionsMigrationIntent,
    runKarpenterMigration: autoscalerApi.autoscalerAPIMigrateKarpenterDefinitions,
    getProblematicNodes: autoscalerApi.autoscalerAPIGetProblematicNodes,
    simulateSpotInterruption: autoscalerApi.autoscalerAPISimulateNodeSpotInterruption,
    getPodMutations: podMutationsApi.podMutationsAPIListPodMutations,
    getPodMutation: podMutationsApi.podMutationsAPIGetPodMutation,
    createPodMutation: podMutationsApi.podMutationsAPICreatePodMutation,
    updatePodMutation: podMutationsApi.podMutationsAPIUpdatePodMutation,
    deletePodMutation: podMutationsApi.podMutationsAPIDeletePodMutation,
    getMutatorScript: podMutationsApi.podMutationsAPIGetPodMutatorInstallCmd,
    getMutatorStatus: podMutationsApi.podMutationsAPIGetPodMutatorStatus,
    previewMatchedWorkloads: podMutationsApi.podMutationsAPIPreviewMatchedWorkloads,
  };
};
